export enum AnswerType {
  OPEN = 'ANSWER_OPEN',
  SCALE = 'ANSWER_SCALE',
  MULTIPLE_CHOICE = 'ANSWER_MULTIPLE_CHOICE',
  GAP_MATCH = 'ANSWER_GAP_MATCH',
  DRAG_DROP = 'ANSWER_DRAG_DROP',
  SELF_EXAM = 'ANSWER_SELF_EXAM',
  LIST = 'ANSWER_LIST',
  KEYWORD = 'ANSWER_KEYWORD',
  READING = 'ANSWER_READING',
}
